import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "payment-requests-transactions-modal__container" }
const _hoisted_2 = {
  key: 0,
  class: "container__state"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "state__message" }, "Загрузка данных...", -1)
const _hoisted_4 = {
  key: 1,
  class: "state__message message--error"
}
const _hoisted_5 = {
  key: 1,
  class: "container__content"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "content__title" }, "История транзакций", -1)
const _hoisted_7 = { class: "content__balance" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "balance__label" }, "Текущий баланс:", -1)
const _hoisted_9 = { class: "balance__value" }
const _hoisted_10 = { class: "content__transactions" }
const _hoisted_11 = { class: "transaction__content" }
const _hoisted_12 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("path", { d: "M7 7h10v10" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("path", { d: "M7 17 17 7" }, null, -1)
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("path", { d: "m7 7 10 10" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("path", { d: "M17 7v10H7" }, null, -1)
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = { class: "content__container" }
const _hoisted_21 = { class: "container__title" }
const _hoisted_22 = { class: "title__type" }
const _hoisted_23 = { class: "container__description" }
const _hoisted_24 = { class: "transaction__additional" }
const _hoisted_25 = ["href"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("svg", {
  class: "additional__file",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M14 2v5a1 1 0 0 0 1 1h5" })
], -1)
const _hoisted_27 = [
  _hoisted_26
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bs_loader = _resolveComponent("bs-loader")!
  const _component_bs_modal_scroll_container = _resolveComponent("bs-modal-scroll-container")!
  const _component_bs_modal = _resolveComponent("bs-modal")!

  return (_openBlock(), _createBlock(_component_bs_modal, {
    "model-value": _ctx.modelValue,
    "onUpdate:modelValue": _ctx.onUpdateModelValue,
    onClose: _ctx.onClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.loading || _ctx.failed)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_3,
                    _createVNode(_component_bs_loader)
                  ], 64))
                : (_ctx.failed)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, "При получении данных произошла ошибка"))
                  : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.formatPriceToTenge(_ctx.balance, { withDecimals: true })), 1)
              ]),
              _createVNode(_component_bs_modal_scroll_container, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transactionHistory, (transaction) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "transactions__transaction",
                        key: transaction.id
                      }, [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["content__icon", { 'icon--green': _ctx.isTopUpOperation(transaction), 'icon--red': !_ctx.isTopUpOperation(transaction) }])
                          }, [
                            (_ctx.isTopUpOperation(transaction))
                              ? (_openBlock(), _createElementBlock("svg", _hoisted_12, _hoisted_15))
                              : (_openBlock(), _createElementBlock("svg", _hoisted_16, _hoisted_19))
                          ], 2),
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("div", _hoisted_22, [
                                (_ctx.isTopUpOperation(transaction))
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode("Пополнение")
                                    ], 64))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode("Выплата")
                                    ], 64))
                              ])
                            ]),
                            _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.formatDate(transaction.createdAt)), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["additional__amount", { 'amount--green': _ctx.isTopUpOperation(transaction), 'amount--red': !_ctx.isTopUpOperation(transaction) }])
                          }, [
                            (transaction.operationId === 1)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode("+ ")
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode("- ")
                                ], 64)),
                            _createTextVNode(" " + _toDisplayString(_ctx.formatPriceToTenge(transaction.amount, { withDecimals: true })), 1)
                          ], 2),
                          (transaction.file)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                href: transaction.file,
                                target: "_blank"
                              }, _hoisted_27, 8, _hoisted_25))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ])
                ]),
                _: 1
              })
            ]))
      ])
    ]),
    _: 1
  }, 8, ["model-value", "onUpdate:modelValue", "onClose"]))
}